import { useState } from "react";
import { getAnalyticsConsentState, setAnalyticsConsent } from "../../engine/analyticsClient.js";
import { PrivacyPolicyLink } from "./PrivacyPolicyLink.js";

/**
 * A small, non-blocking banner offering an explicit choice about
 * anonymous usage analytics - see docs/privacy-security.md for why this
 * defaults to opt-in (analytics OFF until a visitor actively grants it)
 * rather than opt-out. Deliberately does not trap focus or cover the
 * estimator itself: declining, or simply not answering yet, must never
 * prevent someone from using the calculator, requesting a quote, or
 * emailing themselves a copy - none of those features read this choice
 * at all (see LeadCaptureForm.tsx / EmailEstimateForm.tsx).
 */
export function ConsentBanner() {
  const [state, setState] = useState(() => getAnalyticsConsentState());

  if (state.analytics !== "undecided") return null;

  function choose(choice: "granted" | "declined") {
    setState(setAnalyticsConsent(choice));
  }

  return (
    <div className="consent-banner" role="region" aria-label="Privacy choice">
      <p className="consent-banner__text">
        We use anonymous, non-identifying usage analytics to see which parts of this estimator are useful and to fix what
        isn&apos;t. We never send your name, email, phone number, address, or anything you type into a text field. See our{" "}
        <PrivacyPolicyLink />.
      </p>
      <div className="consent-banner__actions">
        <button type="button" className="btn btn--ghost" onClick={() => choose("declined")}>
          Decline analytics
        </button>
        <button type="button" className="btn btn--primary" onClick={() => choose("granted")}>
          Accept analytics
        </button>
      </div>
    </div>
  );
}
